class LfBundleColours extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.scope = this.closest('.shopify-section');
    this.variants = JSON.parse(this.querySelector('[data-bundle-variants]').textContent);
    this.selects = [...this.querySelectorAll('[data-bundle-select]')];
    this.rows = [...this.querySelectorAll('[data-bundle-row]')];
    this.primary = this.selects[0].value;
    this.started = false;
    this.count = 1;
    this.maximumShown = 1;
    this.scope.addEventListener('change', (event) => this.change(event), { signal: this.controller.signal });
    this.syncQuantity();
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  change(event) {
    const target = event.target;
    if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;
    if (target.matches('[data-lf-qty] input[type="radio"]')) this.syncQuantity();
    if (target.matches('variant-picker input[data-variant-id]')) {
      this.primary = target.dataset.variantId;
      if (!this.started) this.selects.forEach((select) => { select.value = this.primary; });
      else this.selects[0].value = this.primary;
      this.render();
    }
    if (this.selects.includes(target)) {
      this.selects.forEach((select) => select.setCustomValidity(''));
      if (target === this.selects[0]) {
        this.primary = target.value;
        const input = this.scope.querySelector(`variant-picker input[data-variant-id="${target.value}"]`);
        if (input && !input.checked) input.click();
      }
      this.render();
    }
  }

  syncQuantity() {
    this.count = Number(this.scope.querySelector('[data-lf-qty] input:checked')?.value || 1);
    if (this.count > 1) {
      if (!this.started) this.selects.forEach((select) => { select.value = this.primary; });
      else this.selects.slice(this.maximumShown, this.count).forEach((select) => { select.value = this.primary; });
      this.started = true;
      this.maximumShown = Math.max(this.maximumShown, this.count);
    }
    this.render();
  }

  render() {
    this.hidden = this.count < 2;
    this.rows.forEach((row, index) => {
      row.hidden = index >= this.count;
      const variant = this.variants.find((item) => item.id === this.selects[index].value);
      if (variant?.image) row.querySelector('img').src = variant.image;
    });
  }

  getItems() {
    const items = new Map();
    this.selects.forEach((select) => select.setCustomValidity(''));
    for (const select of this.selects.slice(0, this.count)) {
      const variant = this.variants.find((item) => item.id === select.value);
      const quantity = (items.get(select.value)?.quantity || 0) + 1;
      let error = '';
      if (!variant?.available) error = this.dataset.invalid;
      else if (variant.maximum !== null && quantity > variant.maximum) error = this.dataset.stockError;
      if (error) {
        select.setCustomValidity(error);
        select.reportValidity();
        return [];
      }
      items.set(select.value, { variantId: select.value, quantity });
    }
    return [...items.values()];
  }
}

if (!customElements.get('lf-bundle-colours')) customElements.define('lf-bundle-colours', LfBundleColours);
